import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpenseTypes = {
  OTHER: 0,
  MEALS: 1,
  MILEAGE: 2,
  LABOUR: 3,
  AIRFARE: 4,
  LODGING: 5,
} as const

export type ExpenseTypeEnum = Enum<typeof ExpenseTypes>
